module.exports = __webpack_public_path__ + "media/images/rename-light-6bca838c0da7f58b354020073d8d775b.svg";